import BanyanMark from "@/components/BanyanMark";

export default function BookCover({ book, title, className = "" }) {
  return (
    <div
      className={`relative aspect-[2/3] w-full select-none overflow-hidden rounded-[3px] ${className}`}
      style={{
        background: `linear-gradient(155deg, ${book.cover[0]} 0%, ${book.cover[1]} 100%)`,
      }}
      role="img"
      aria-label={`Book cover of ${book.title} by Arlo Jungle`}
    >
      {book.image && (
        <>
          <img
            src={book.image}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/5 to-black/65" />
        </>
      )}
      <div className="absolute inset-y-0 left-0 w-[5%] bg-black/35" />
      <div className="absolute inset-y-0 left-[5%] w-px bg-white/10" />
      <div className="absolute inset-[7%] border border-gold/55" />
      <div className="absolute inset-[9.5%] border border-gold/25" />

      <div className="absolute inset-0 flex flex-col items-center justify-between px-[16%] py-[13%] text-center">
        <div>
          <p className="font-mono text-[8px] uppercase tracking-[0.32em] text-gold sm:text-[9px] [text-shadow:0_1px_6px_rgba(0,0,0,0.8)]">
            Panchatantra Tales
          </p>
          <p className="mt-1 font-mono text-[8px] uppercase tracking-[0.32em] text-gold/70 sm:text-[9px] [text-shadow:0_1px_6px_rgba(0,0,0,0.8)]">
            Vol. {book.roman}
          </p>
        </div>
        <div className="flex flex-col items-center">
          <img
            src="/logo-192.webp"
            alt=""
            aria-hidden="true"
            className="mb-3 h-9 w-9 rounded-full ring-1 ring-gold/60 drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] sm:h-11 sm:w-11"
          />
          <h3 className="font-serif text-lg font-semibold leading-[1.15] text-cream [text-shadow:0_2px_10px_rgba(0,0,0,0.85)] sm:text-xl">
            {title || book.title}
          </h3>
          <span className="mt-3 block h-px w-10 bg-gold/80" />
        </div>
        <p className="font-mono text-[8px] uppercase tracking-[0.3em] text-cream/85 [text-shadow:0_1px_6px_rgba(0,0,0,0.8)] sm:text-[9px]">
          Arlo Jungle
        </p>
      </div>

      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-black/30" />
    </div>
  );
}
